const FAQ_DATA = [
  {
    "title": "Why Did Charli3 Make NFTs?",
    "content": "Community engagement is at the forefront of our focus and NFTs are a great vehicle for achieving this initiative.  We also aim to promote the great team at Canucks NFT."
  },
  {
    "title": "Will there be more?",
    "content": "Yes! We aim to sell unique and limited run NFT creations to distribute or be purchased in a multitude of ways, including auctions on cardano smart contracts in the future."
  },
  {
    "title": "Why Canuckz?",
    "content": "With our team being largly Canadian we were drawn to another Canadian team! We were excited that the team has been set up since the very beginning and that they offer minting services and Cardano NFT Consulting."
  }
]

export default FAQ_DATA;